import React, { createContext, useContext } from "react";
import { FilterCompaniesAction } from "../FilterCompaniesProvider";
import { Company } from "@/types/company";
import { CompanyFilterOptions } from "@/hooks";
import { PaginationState } from "@/hooks/companies/useCompanies";

export interface CompanyFiltersState {
  selectedCompanies: CompanyFilterOptions["selectedCompanies"];
  selectedCompanySizes: CompanyFilterOptions["selectedCompanySizes"];
  selectedFundingTypes: CompanyFilterOptions["selectedFundingTypes"];
  selectedCompanyTypes: CompanyFilterOptions["selectedCompanyTypes"];
  selectedHealthcareDomains: CompanyFilterOptions["selectedHealthcareDomains"];
  selectedOperatingStatus: Company["operating_status"][];
  selectedLocations: CompanyFilterOptions["selectedLocations"];
  selectedYearRangeMin: Company["year_founded"];
  selectedYearRangeMax: Company["year_founded"];
  search?: string;
}

interface FilterCompaniesStateContextProps {
  companies: Company[];
  filters: CompanyFiltersState;

  loading: boolean;
  error: string | null;
  dispatch: React.Dispatch<FilterCompaniesAction>;

  resetFilters: () => void;
  noMatchingResults: boolean;
  getNoResultsMessage: () => string;

  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  pagination: PaginationState;
}

export const FilterCompaniesStateContext =
  createContext<FilterCompaniesStateContextProps | null>(null);

export function useFilterCompanies() {
  const context = useContext(FilterCompaniesStateContext);
  if (!context) {
    throw new Error(
      "useFilterCompanies must be used within a FilterCompaniesStateProvider",
    );
  }
  return context;
}
